var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthiconsYesOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 81.3751C65.7607 81.3751 81.375 65.7608 81.375 46.5001C81.375 27.2394 65.7607 11.6251 46.5 11.6251C27.2393 11.6251 11.625 27.2394 11.625 46.5001C11.625 65.7608 27.2393 81.3751 46.5 81.3751ZM46.5 85.2501C67.9016 85.2501 85.25 67.9017 85.25 46.5001C85.25 25.0985 67.9016 7.75012 46.5 7.75012C25.0984 7.75012 7.75 25.0985 7.75 46.5001C7.75 67.9017 25.0984 85.2501 46.5 85.2501Z",
    fill: "#006131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.172 31.502C67.5532 31.8463 67.782 32.328 67.8082 32.841C67.8343 33.354 67.6557 33.8564 67.3115 34.2377L41.4343 62.8372L25.787 47.901C25.4357 47.5419 25.2375 47.0604 25.2344 46.558C25.2313 46.0557 25.4234 45.5717 25.7702 45.2083C26.1171 44.8449 26.5915 44.6304 27.0935 44.61C27.5955 44.5897 28.0857 44.7652 28.4608 45.0994L41.2289 57.2862L64.4382 31.6395C64.609 31.4508 64.8153 31.2976 65.0454 31.1886C65.2754 31.0796 65.5247 31.017 65.779 31.0044C66.0332 30.9919 66.2874 31.0295 66.5271 31.1152C66.7668 31.2009 66.9873 31.333 67.1759 31.5039",
    fill: "#006131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthiconsYesOutline);
export default __webpack_public_path__ + "static/media/healthicons_yes-outline.fd5c6a272c74e80956e567ab7f4d710a.svg";
export { ForwardRef as ReactComponent };